'use strict';

var React = require("react");

function Input(Props) {
  var strand = Props.strand;
  var onChange = Props.onChange;
  var children = Props.children;
  return React.createElement(React.Fragment, undefined, React.createElement("label", {
                  htmlFor: "dna"
                }, children), React.createElement("textarea", {
                  id: "dna",
                  placeholder: "Enter the template strand",
                  value: strand.join(""),
                  onChange: onChange
                }));
}

var make = Input;

exports.make = make;
/* react Not a pure module */
